import { styled } from '../../../core/theme/styled';

export const ImageContainer = styled.div`
  position: absolute;
  left: 37%;
  top: 10%;
`;

export const StyledImage = styled.img`
  height: 40px;
`;

export const IconContainer = styled.div`
  position: relative;
  width: 160px;
  margin-left: auto;
  margin-right: auto;
`;

export const ThemedIcon = styled.div`
  position: relative;
  top: 0;
  left: 0;
  & rect.primaryColor {
    fill: ${(props) => props.theme.configuration.backgroundColor};
    stroke: ${(props) => props.theme.configuration.primaryColor};
  }
  & path.primaryColor {
    fill: ${(props) => props.theme.configuration.primaryColor};
  }
  & path.backgroundColor {
    fill: ${(props) => props.theme.configuration.backgroundColor};
  }
  & circle.tintedBackgroundColor {
    fill: ${(props) => props.theme.configuration.tintedBackgroundColor};
  }
`;
